import React, {useState, useEffect} from 'react';
import {Container, Col, Button, Row} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import HeadLineComponent from '../HeadLineComponent';
import SendSmsComponent from '../SendSmsComponent';
import PaymentProcessBackComponent from '../PaymentProcessBackComponent';
import EmailComponent from './EmailComponent';
import PaymentCG from '../../SaleBlock/PaymentCG/PaymentCG';
import BankComponent from '../BankPaymentMethod/BankComponent';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../../Shared/Buttons/BtnWhite';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {cgTypeEnum} from '../../../../utilities/enums/cgTypeEnum';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import PopupContent from '../SelectCustomers/PopupContent';
import PopUp from '../../../Shared/Popup/PopUp';
import Config from '../../../../Config';
import images from '../images/images';
import {gaReportShownPage, gaReportOnButtonClick, gaReportOnClickUpdateBtnPrivate} from './../gaReports';
import stageConfig from 'app/StageConfig';
import './style.scss';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import Image from 'app/Components/Shared/Image/image';
import EpiContext from '@episerver/spa-core/Spa';
import {prepareUrl} from '../../../../utilities/StringHelpers/StringHelpers';
const UpdatePaymentProcessComponent = ({
  props,
  createAndSendPaymentData,
  changeHandler,
  validateEmail,
  resetPaymentCGState,
  setPrivateUserUpdateObj,
  setCompletedFlag,
  isAllowedOtherPayment,
}) => {
  if (props.data.currentStep !== 5) {
    return null;
  }
  const [showSMSComponent, setShowSMSComponent] = useState(false);
  const [showErrorAsPopup, setShowErrorAsPopup] = useState(false);
  const validCC = !props.data.isBusinessBlock && props.privateUserUpdateResultObj?.validCC;

  const banToIdOfCCError =
    (!props.data.isBusinessBlock && props.privateUserUpdateResultObj?.failedUpdateReason === 'BanDontMatchId') ||
    (!props.data.isBusinessBlock && props.privateUserUpdateResultObj?.failedUpdateReason === 'BanUnrelatedToCustomer')
      ? true
      : false;
  const accountWithDebt = !props.data.isBusinessBlock ? props.data?.accountHasDebt : false;
  const banIdIssues =
    'שימו לב! כרטיס אשראי החדש אינו שייך לבעל החשבון בכל החשבונות שבחרתם (ת.ז. של כרטיס אשראי חייבת להיות זהה לת.ז. של בעל החשבון)';
  const errorTxt = `.לא ניתן לעדכן לכרטיס אשראי זה נסו כרטיס אשראי אחר או צרו קשר עם שירות לקוחות ב ${window.Config.technicalSupportPhone} בשעות הפעילות`;
  const customerIds = !props.data.isBusinessBlock ? getCustomerIdsData() : '';

  function getCustomerIdsData() {
    if (props.data.customerAdditionalIdList?.length > 0) {
      return props.data.customerAdditionalIdList;
    }
    return props.data.customerId;
  }

  function isSingleCustomerId(customerIds) {
    if (Array.isArray(customerIds)) {
      return customerIds.length === 1;
    }
    return !!customerIds;
  }

  function reportPrivateFlowGA() {
    gaEvent(
      gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_CC_INPUT_PAGE.category,
      gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_CC_INPUT_PAGE.eventType,
      gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_CC_INPUT_PAGE.eventParams,
    );
  }

  useEffect(() => {
    if (!props.data.isBusinessBlock) {
      reportPrivateFlowGA();
    }
  }, []);

  const [agreement, toggleAgreement] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [animateOut, setAnimateOut] = useState(false);
  const [showPrivateUserPopup, setShowPrivateUserPopup] = useState(false);

  const gaEventCCError = () => {
    gaEvent(
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_CCERROR.category,
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_CCERROR.eventType,
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_CCERROR.eventParams,
    );
  };

  const gaEventFormError = () => {
    gaEvent(
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_FORMERROR.category,
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_FORMERROR.eventType,
      gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_FORMERROR.eventParams,
    );
  };

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    if (props.data.isBusinessBlock) {
      const pageName = props.data.newSelectedPaymentMethod === 'Bank' ? 'bank_payment_form' : 'credit_card_payment_form';
      gaReportShownPage(pageName);
    }

    setTimeout(() => {
      props.setProgressBarPercent(80);
    }, props.data.animationTimeOut);
  }, []);

  useEffect(() => {
    if (!props.data.isBusinessBlock && isAllowedOtherPayment?.value) {
      setShowPrivateUserPopup(true);
    }
  }, []);

  //animation
  useEffect(() => {
    if (props.data.completed) {
      setAnimateOut(true);
      setTimeout(() => {
        if (!props.data.isBusinessBlock && props.privateUserUpdateResultObj?.validCC === false) {
          gaEvent(
            gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_CC_BLACKLIST_POPUP.category,
            gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_CC_BLACKLIST_POPUP.eventType,
            gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_CC_BLACKLIST_POPUP.eventParams,
          );
          setShowErrorAsPopup(true);
          return;
        }
        if (!props.data.isBusinessBlock && banToIdOfCCError) {
          gaEvent(
            gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_BAN_NOT_RELATED_TO_CC_ID_POPUP.category,
            gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_BAN_NOT_RELATED_TO_CC_ID_POPUP.eventType,
            gaParams.UPDATE_PRIVATE_PAYMENT_DISPLAY_BAN_NOT_RELATED_TO_CC_ID_POPUP.eventParams,
          );
          setShowErrorAsPopup(true);
          return;
        }
        props.handleCurrentStep(6);
      }, props.data.animationTimeOut);
    }
  }, [props.data.completed]);

  //button disabled status
  useEffect(() => {
    if (
      (props.data.newSelectedPaymentMethod === 'CC' && props.paymentCg.CCToken) ||
      (props.data.newSelectedPaymentMethod === 'Bank' && props.bankPayment.form.validatedFileName.trim() != '' && agreement)
    ) {
      setDisabledBtn(false);
    } else {
      setDisabledBtn(true);
    }
  }, [props.data.newSelectedPaymentMethod, props.bankPayment.form.validatedFileName, props.paymentCg.CCToken, agreement]);

  //save to back history bank data
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects() && props.bankPayment.form.validatedFileName) {
        props.saveToHistory();
      }
    },
    [props.bankPayment.form.validatedFileName],
  );

  //save to back history EMV data
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects() && props.paymentCg.CCToken) {
        props.saveToHistory();
      }
    },
    [props.paymentCg.CCToken],
  );

  const submitPaymentData = async () => {
    if (!props.data.isBusinessBlock) {
      gaReportOnClickUpdateBtnPrivate();
    } else {
      gaReportOnButtonClick('submit_update_payment_method');
    }

    if (props.data.newSelectedPaymentMethod === 'Bank') {
      //Bank Payment
      if (!props.bankPayment.error && props.bankPayment.form.validatedFileName.trim() != '' && agreement) {
        createAndSendPaymentData();
      } else {
        gaEvent(
          gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.category,
          gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.eventType,
          gaParams.UPDATE_PAYMENT_METHOD_SHOW_FORM_ERROR.eventParams,
        );
      }
    } else {
      // CC Payment
      if (props.paymentCg.CCToken) {
        createAndSendPaymentData();
      } else {
        gaEvent(
          gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_FORMERROR.category,
          gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_FORMERROR.eventType,
          gaParams.UPDATE_PAYMENT_METHOD_SHOW_CREDITCARDPAY_FORMERROR.eventParams,
        );
      }
    }
  };

  //CC Payment event
  function handleCreditCardValidation() {
    if (!props.paymentCg.CCToken) {
      if (submitted) {
        setSubmitted(false);
      }
    }
  }

  const setCheckbox = () => {
    toggleAgreement(!agreement);
  };

  const backToSelectCustomersStep = () => {
    if (!props.data.isBusinessBlock) {
      gaEvent(
        gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_GO_BACK_TO_CHOOSE_UPDATE_OPTIONS.category,
        gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_GO_BACK_TO_CHOOSE_UPDATE_OPTIONS.eventType,
        gaParams.UPDATE_PRIVATE_PAYMENT_CLICK_GO_BACK_TO_CHOOSE_UPDATE_OPTIONS.eventParams,
      );
    }
    setAnimateOut(true);
    setTimeout(() => {
      props.handleCurrentStep(3);
    }, props.data.animationTimeOut);
  };

  const closeModal = () => {
    resetPaymentCGState();
    setCompletedFlag(false);
    setPrivateUserUpdateObj(null);
    setShowErrorAsPopup(false);
  };

  const handlePrivatePopupClose = () => {
    setShowPrivateUserPopup(false);
  };

  const handlePrivatePopupLinkClick = () => {
    setShowPrivateUserPopup(false);
    setShowSMSComponent(true);
  };

  const PAYMENT_CG_IFRAME_HEIGHT = ['production', 'golan-production'].includes(stageConfig.stage) ? 300 : 400;
  return (
    <div className={`${animateOut ? 'animateOut' : 'animateIn'}`} style={{position: 'relative'}}>
      {!showSMSComponent ? (
        <>
          <div className='back-text-payment-method-button' onClick={() => backToSelectCustomersStep()}>
            <Image src={images.backArrow} alt='חזרה' />
          </div>
          <HeadLineComponent text={'פרטי כרטיס האשראי החדש'} />
          <Container>
            {!props.data.isDeptPayment && (
              <PaymentProcessBackComponent
                selectedPaymentMethods={props.data.selectedPaymentMethods}
                selectedInvoices={props.data.selectedInvoices}
                buttonFunction={backToSelectCustomersStep}
              />
            )}

            <Row>
              {props.data.newSelectedPaymentMethod === 'CC' ? (
                <Col className={`background-container p-0 ${showErrorAsPopup ? 'payment-popup-opened' : ''}`}>
                  {!showErrorAsPopup ? (
                    <PaymentCG
                      isShowIdNumber={!props.data.isBusinessBlock && isSingleCustomerId(customerIds)}
                      type={cgTypeEnum.CHECKCARD}
                      onValid={handleCreditCardValidation}
                      onSubmit={submitted}
                      isValid={agreement}
                      //onError={handleOnError}
                      isUpdatePayment={true}
                      termsLink={props.cmsData.serviceTermsLink?.value}
                      customerId={isSingleCustomerId(customerIds) ? customerIds : null}
                      blockId={props.data.isBusinessBlock ? props.data.blockId : ''}
                      source='UpdatePaymentMethodBlock'
                      iframeHeight={PAYMENT_CG_IFRAME_HEIGHT}
                    />
                  ) : null}
                </Col>
              ) : (
                <Col className='background-container bank-payment-component '>
                  <BankComponent onSubmit={submitted} contactId={props.data.contactId} />
                  {props.cmsData.serviceTermsLink?.value && (
                    <Row className='termOfService'>
                      <Col xs='1' md='1' className='termOfService__checkbox pr-0 pl-0'>
                        <div>
                          <CheckBox
                            id='agreement'
                            onCheck={(e) => toggleAgreement(true)}
                            onUncheck={(e) => toggleAgreement(false)}
                            checked={agreement}></CheckBox>
                        </div>
                      </Col>
                      <Col xs='11' md='11'>
                        <p className='termOfService__link'>
                          אישרתי את{' '}
                          <span
                            className='termOfService__link__url'
                            onClick={() => prepareUrl(props.cmsData.serviceTermsLink?.value, EpiContext)}>
                            תקנון השירות
                          </span>
                        </p>
                      </Col>
                    </Row>
                  )}
                </Col>
              )}
            </Row>

            {isAllowedOtherPayment.value && !props.data.isBusinessBlock ? (
              <div className='insight-container-payment'>
                <Image src={images.insight} className='path' style={{width: '18px', height: '18px'}}></Image>
                <p className='insight-container-payment-text'>
                  רוצה לעדכן אשראי שלא שלך?{' '}
                  <a className='text' onClick={() => setShowSMSComponent(true)} style={{cursor: 'pointer', textDecoration: 'underline'}}>
                    לעדכון
                  </a>
                </p>
              </div>
            ) : !props.data.isBusinessBlock && !isAllowedOtherPayment.value ? (
              <div className='insight-container'>
                <Image src={images.insight} className='path'></Image>
                <span className='text'>לעדכון החשבון בהוראת קבע פנו למוקד {window.Config.financeCallNumber1}</span>
              </div>
            ) : null}

            <Row>
              <Col xs={12} className={`btn-337 text-center mt-3 ${disabledBtn ? 'disabled-btn' : ''}`}>
                <BtnSubmit
                  isBusiness={props.data.isBusinessBlock}
                  text='עדכון וסיום'
                  onclick={() => (disabledBtn ? null : submitPaymentData())}
                />
              </Col>
            </Row>
          </Container>

          <PopUp showPopUp={showErrorAsPopup} onClose={() => closeModal()}>
            <PopupContent
              buttonFunction={closeModal}
              closeModal={closeModal}
              title='שימו לב'
              cancelBtnText='אוקיי'
              btnText='אוקיי'
              validCC={validCC}
              errorTxt={!validCC ? errorTxt : banIdIssues}
              banToIdOfCCError={banIdIssues}
              isBusiness={props.data.isBusinessBlock}
            />
          </PopUp>

          <PopUp
            showPopUp={showPrivateUserPopup}
            onClose={handlePrivatePopupClose}
            className='private-entitypayment-popup'
            footerBtn={{
              text: 'הבנתי, תודה',
              onBtnClick: handlePrivatePopupClose,
            }}>
            <div className='private-entitypayment-popup-content'>
              <div className='private-entitypayment-popup-icon-container'>
                <Image src={images.bigInsight} alt='lightbulb' />
              </div>
              <h2 className='private-entitypayment-popup-title'>
                אפשר לעדכן לאשראי השייך <br /> לבעל החשבון
              </h2>
              <p className='private-entitypayment-popup-description'>
                רוצים לעדכן לאשראי שלא שלכם? <br />
                <a
                  href='#'
                  onClick={(e) => {
                    e.preventDefault();
                    handlePrivatePopupLinkClick();
                  }}
                  className='private-entitypayment-popup-link'>
                  לחצו כאן
                </a>
              </p>
            </div>
          </PopUp>
        </>
      ) : (
        <SendSmsComponent
          props={props}
          onBack={() => setShowSMSComponent(false)}
          onComplete={() => {
            setShowSMSComponent(false);
          }}
        />
      )}
    </div>
  );
};

export default UpdatePaymentProcessComponent;
